import { z } from 'zod';
import { isoDateTimeSchema } from './common.js';
export const addressResolutionCountrySchema = z.enum(['DE', 'FR']);
export const addressResolutionQuerySchema = z
    .object({
    countryCode: z.string().trim().toUpperCase().pipe(addressResolutionCountrySchema),
    postalCode: z.string().trim(),
})
    .superRefine((value, context) => {
    if (!/^\d{5}$/.test(value.postalCode)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['postalCode'],
            message: 'Für Deutschland und Frankreich sind genau fünf Ziffern erforderlich.',
        });
    }
});
export const addressResolutionSuggestionSchema = z.object({
    id: z.string(),
    countryCode: addressResolutionCountrySchema,
    postalCode: z.string(),
    city: z.string(),
    region: z.string().nullable(),
    regionCode: z.string().nullable(),
    district: z.string().nullable(),
    districtCode: z.string().nullable(),
    administrativeCode: z.string().nullable(),
});
export const addressResolutionSourceSchema = z.object({
    id: z.enum(['OPENPLZ', 'API_GOUV_FR']),
    name: z.string(),
    version: z.string(),
    license: z.string(),
    licenseUrl: z.string().url(),
    sourceUrl: z.string().url(),
    retrievedAt: isoDateTimeSchema,
    cacheStatus: z.enum(['MISS', 'HIT', 'STALE']),
});
export const addressResolutionResponseSchema = z.object({
    data: z.array(addressResolutionSuggestionSchema),
    source: addressResolutionSourceSchema,
});
export const addressRegionOriginSchema = z.enum(['AUTO', 'MANUAL']).nullish();
export const regionAddressSchema = z.object({
    countryCode: z.string().nullish(),
    postalCode: z.string().nullish(),
    city: z.string().nullish(),
    region: z.string().nullish(),
    regionOrigin: addressRegionOriginSchema,
});
export const addressRegionDecisionSchema = z.object({
    status: z.enum([
        'RESOLVED',
        'INCOMPLETE',
        'UNSUPPORTED',
        'NO_MATCH',
        'CONFLICT',
        'AMBIGUOUS',
        'MISSING_REGION',
        'UNAVAILABLE',
    ]),
    region: z.string().nullable(),
    regionCode: z.string().nullable(),
    city: z.string().nullable(),
});
export const regionBackfillQuerySchema = z.object({
    kind: z.enum(['PARTNER', 'ADDRESS']),
    after: z.string().max(100).optional(),
});
export const regionBackfillRowSchema = z.object({
    id: z.string(),
    label: z.string(),
    countryCode: z.string(),
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
    updatedAt: isoDateTimeSchema,
    decision: addressRegionDecisionSchema,
});
export const regionBackfillPreviewSchema = z.object({
    token: z.string(),
    kind: z.enum(['PARTNER', 'ADDRESS']),
    rows: z.array(regionBackfillRowSchema),
    nextCursor: z.string().nullable(),
    expiresAt: isoDateTimeSchema,
});
export const regionBackfillApplySchema = z.object({
    token: z.string().max(100_000),
    ids: z.array(z.string()).min(1).max(50),
    confirmed: z.literal(true),
});
export const regionBackfillResultSchema = z.object({
    updated: z.array(z.string()),
    skipped: z.array(z.string()),
});
//# sourceMappingURL=address-resolution.js.map